<template>
  <div>
    <div class="content">
      <div class="left">
        <!-- active_ticket -->
        <!-- no_ticket -->
        <df-step></df-step>

        <div class="passengers_title" style="margin-bottom:20px;margin-top:25px;">
          <div>备选车次 ( 多选 )</div>
        </div>

        <div class="ticket_type">
          <div
            v-for="(item, index) in trainList"
            :key="index"
            :class="{ active_ticket: item.checked }"
            @click="checkTrain(index)"
          >
            <div class="action_sanjiao"></div>
            <div class="train_no">{{ item.trainNo }}</div>
            <div class="time_cont">
              <span>{{ item.fromTime }}</span>
              <span class="take_time">{{ item.takeTimeFormat }}</span>
              <span>{{ item.toTime }}</span>
            </div>
            <div class="price_line"></div>
            <div class="state_cont">
              <span>{{ item.fromStation }}</span>
              <span>{{ item.toStation }}</span>
            </div>
          </div>

          <div class="add_ticket" style="height:99px" @click="choseTrainShow = true">
            <PlusCircleFilled :style="{ color: '#3999FB' }" /><span style="margin-left:10px"
              >添加其他车次（ {{ choseTrainNum }} / 7 ）</span
            >
          </div>
        </div>

        <div class="passengers_title" style="margin-top:35px">
          <div>备选坐席 ( 多选 )</div>
        </div>
        <div class="seat_content">
          <div
            v-for="(item, index) in setSeatList"
            :key="index"
            :class="{ active_ticket: choseSeatList.indexOf(item.seatType) > -1 }"
            @click="choseSeat(item.seatType)"
          >
            {{ item.seatName }} ¥{{ item.price }}
            <div class="action_sanjiao" v-show="choseSeatList.indexOf(item.seatType) > -1"></div>
          </div>
        </div>

        <div class="passengers_title" style="margin-top:35px">
          <div>备选日期 ( 多选 )</div>
        </div>
        <div class="seat_content showdatacontent">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            :class="{ active_ticket: item.chose }"
            @click="changeDate(item)"
          >
            {{ item.showdate }}
            <div class="action_sanjiao" v-show="item.chose"></div>
          </div>
        </div>

        <div class="passengers_title" style="margin-top:35px;margin-bottom:9px">
          <div>截止日期</div>
        </div>
        <a-date-picker
          v-model:value="limitdate"
          valueFormat="YYYY-MM-DD"
          placeholder="请选择截止日期"
          :disabledDate="limitDisabledDate"
        />

        <div class="passengers_cont">
          <div class="passengers_title">
            <div>乘客信息 {{ passengerLength }}/5</div>
            <div class="add" @click="addUserAction">
              <PlusCircleFilled :style="{ color: '#FD5839' }" />
              添加乘客
            </div>
          </div>
          <div class="passengers_list" :class="{ moreShow: moreShow }">
            <div
              class="passengers_item"
              v-for="(item, index) in userList"
              :key="index"
              :class="{ passengers_disabel: item.state != 20, passengers_active: item.checked }"
              @click="selectUser(index, item.state != 20)"
            >
              <div class="name">
                <div>{{ item.name }}</div>
                <div class="tips" v-show="item.state != 20">{{ item.stateValue }}</div>
                <div class="tips" v-show="item.state == 20">{{ item.passengerTypeValue }}</div>
                <div class="line"></div>
                <div class="operation">
                  <div @click.stop="editUser(index)">编辑</div>
                  <div v-if="item.state == 20" @click.stop="deleteUser(index)">删除</div>
                  <div v-else @click.stop="reloadUser" style="color:#FD5739!important">刷新</div>
                </div>
              </div>
              <div class="action_sanjiao" v-show="item.checked"></div>
            </div>
          </div>

          <div class="passengers_more" @click="moreShow = !moreShow" v-show="userList.length > 8">
            {{ moreShow ? "收起" : "更多乘客" }}
          </div>
        </div>
        <div class="confirm_passengers">
          <template v-for="(item, index) in userList" :key="index">
            <a-row class="confirm_list" v-if="item.checked">
              <a-col :span="6" class="passengers_name">
                {{ item.name || item.passengerName }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                {{ item.passengerTypeValue }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                <span v-show="item.passengerType == 2">限高1.5米</span>
              </a-col>
              <a-col :span="5" class="addchildredn">
                <span v-show="item.passengerType == 1" @click="addChildren(index)">
                  <img src="@assets/img/children.png" />
                  <span>添加儿童<span style="color: #b9b9b9; font-size: 12px">(用成人证件)</span></span>
                </span>
              </a-col>
              <a-col :span="5" class="delete_passengers">
                <div @click="selectUser(index, false)">
                  <CloseCircleOutlined />
                </div>
              </a-col>
            </a-row>

            <a-row class="confirm_list" v-for="(data, dataIndex) in item.children" :key="index">
              <a-col :span="6" class="passengers_name">
                {{ data.name || item.passengerName }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                {{ data.passengerTypeValue }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                <span>限高1.5米</span>
              </a-col>
              <a-col :span="5" class="addchildredn"> </a-col>
              <a-col :span="5" class="delete_passengers">
                <div @click="deleteChildren(index)">
                  <CloseCircleOutlined />
                </div>
              </a-col>
            </a-row>
          </template>
        </div>

        <div class="contact">
          <div class="contact_title">联系手机号</div>
          <div class="contact_content">
            <span>手机<span class="tips">(+86)</span>:</span>
            <a-input v-model:value="contact" placeholder="用于购买人接收短信" class="input" />
          </div>
        </div>

        <!-- 保险 -->
        <div class="insurance" v-if="passengerLength">
          <div class="insurance_title"><img src="@assets/img/baoxian.png" />全方位保护您的旅程安全</div>
          <div
            class="insurance_content"
            v-for="(item, index) in insuranceList"
            :key="index"
            @click="changeInsurance(item)"
          >
            <div class="insurance-top">
              <div>
                <div class="name">{{ item.insuranceName }}</div>
                <div>
                  保额:
                  <span>{{ insuredAmountText(item.insuredAmount) }}</span>
                </div>
              </div>
              <div class="price">
                ¥{{ item.premium }}/人
                <a-checkbox v-model:checked="item.isSelected" :value="item.id"></a-checkbox>
              </div>
            </div>
            <div class="insurance-bottom">
              阅读[
              <span>保险条款</span>
              ] 和 [
              <span>投保须知</span>
              ]
            </div>
          </div>
        </div>

        <a-button type="primary" class="submitBtn" @click="submitRobOrder()" :loading="submitloading">
          提交抢票单
        </a-button>
      </div>

      <div class="right">
        <div class="ticket_detail">
          <div class="top">
            <div>{{ mainDate }} 出发</div>
            <div class="train_no">{{ initialize.trainNo }}</div>
          </div>
          <div class="time_cont">
            <div class="state">
              <div>{{ initialize.fromTime }}</div>
              <div style="font-size:14px">{{ initialize.fromStation }}</div>
            </div>
            <div class="often">
              <div>{{ initialize.takeTimeFormat }} <img src="@assets/img/idcard.png" class="card" /></div>
              <div><img src="@assets/img/cardline.png" /></div>
              <div style="color:#3999fb;cursor: pointer;" @click="stopShowAction(initialize)">
                经停站
              </div>
              <transition name="fade-transform" mode="out-in">
                <div class="box" v-show="stateListShow">
                  <div class="box_title">
                    经停站<CloseCircleOutlined
                      :style="{
                        color: '#6D7278'
                      }"
                      @click="close"
                    />
                  </div>
                  <div class="box-content">
                    <a-row class="row_content row_title">
                      <a-col span="2"></a-col>
                      <a-col span="5">车站名</a-col>
                      <a-col span="6">到达时间</a-col>
                      <a-col span="6">发车时间</a-col>
                      <a-col span="5">停留时间</a-col>
                    </a-row>
                    <div class="row_list_content">
                      <a-skeleton active v-if="!stopStateList.length" />
                      <a-row class="row_content row_list" v-for="(item, index) in stopStateList" :key="index">
                        <a-col span="2">{{ item.serialNumber }}</a-col>
                        <a-col span="5">{{ item.station }}</a-col>
                        <a-col span="6">{{ item.arrivalTime }}</a-col>
                        <a-col span="6">{{ item.departureTime }}</a-col>
                        <a-col span="5">{{ item.stayTimeSpan }}</a-col>
                      </a-row>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="state">
              <div>{{ initialize.toTime }}</div>
              <div style="font-size:14px;">{{ initialize.toStation }}</div>
            </div>
          </div>
        </div>
        <div class="price_content">
          <div class="price_title">票价信息</div>

          <div class="price_item">
            <div>{{ totleDetail.seatClassVal }}</div>
            <div>¥{{ totleDetail.unitPrice }}*{{ totleDetail.number }}张</div>
          </div>
          <div class="price_item" v-if="totleDetail.servicePrice">
            <div>服务费</div>
            <div>¥{{ totleDetail.servicePrice }}</div>
          </div>

          <div class="price_item" v-if="totleDetail.insurancePrice">
            <div>保险费</div>
            <div>¥{{ totleDetail.insurancePrice }}</div>
          </div>

          <div class="price_totle">
            <div class="dro">订单总额（ 约 ）</div>
            <div class="num">¥{{ totleDetail.price }}</div>
          </div>
        </div>
      </div>
    </div>

    <a-modal title="可选车次" v-model:visible="choseTrainShow" :footer="null" :keyboard="false" :maskClosable="false">
      <div class="train_list">
        <div class="train_title">可选车次</div>

        <a-row>
          <a-col :span="3" class="t1">
            车次
          </a-col>

          <a-col :span="16" class="t2">
            发车时间
          </a-col>

          <a-col :span="5" class="t3">
            选择车次
          </a-col>
        </a-row>
        <div class="scroll">
          <template v-if="totleDetail.trainSearchBo">
            <a-row class="row" v-for="(item, index) in totleDetail.trainSearchBo.trains" :key="index">
              <a-col :span="3" class="t1">
                {{ item.trainNo }}
              </a-col>

              <a-col :span="16" class="t2">
                {{ item.fromTime }}
              </a-col>

              <a-col :span="5" class="t3">
                <a-button
                  type="primary"
                  class="searchBtn"
                  :class="{ no_confim: trainNoList.indexOf(item.trainNo) > -1 }"
                  @click="addTrainList(item, trainNoList.indexOf(item.trainNo) > -1)"
                >
                  选择
                </a-button>
              </a-col>
            </a-row>
          </template>
        </div>
      </div>
    </a-modal>

    <a-modal
      title="Title"
      v-model:visible="addvisible"
      :footer="null"
      :closable="false"
      :keyboard="false"
      :maskClosable="false"
    >
      <div class="add_content">
        <a-form :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" :ref="toref">
          <div class="form_title">{{ editid ? "编辑" : "创建" }}乘客</div>
          <a-form-item label="乘客类型：" class="bdbtm1" name="passengerType">
            <a-radio-group
              v-model:value="form.passengerType"
              button-style="solid"
              :disabled="editid != '' && editState == 20"
            >
              <a-radio-button v-for="(item, index) in typeList" :key="index" :value="item.val">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="证件类型：" class="bdbtm1 required" name="cardType">
            <a-select
              v-model:value="form.cardType"
              style="width: 320px"
              :placeholder="'请选择证件类型'"
              size="small"
              :disabled="editid != '' && editState == 20"
            >
              <a-select-option v-for="(item, index) in cardType" :key="index" :value="item.val">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="乘客姓名：" class="bdbtm1" name="name">
            <a-input
              v-model:value="form.name"
              placeholder="请填写乘客姓名"
              style="width: 320px"
              :disabled="editid != '' && editState == 20"
            />
          </a-form-item>

          <a-form-item label="乘客性别：" class="bdbtm1" name="sex" v-if="form.cardType && form.cardType != 1">
            <a-radio-group v-model:value="form.sex" button-style="solid">
              <a-radio-button value="M">
                男
              </a-radio-button>
              <a-radio-button value="F">
                女
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            label="乘客生日："
            class="bdbtm1 required"
            name="birthday"
            v-if="form.cardType && form.cardType != 1"
          >
            <a-date-picker
              v-model:value="form.birthday"
              :disabled="editid != '' && editState == 20"
              type="date"
              placeholder="选择生日"
              valueFormat="YYYY-MM-DD"
              :disabled-date="disabledDate"
              style="width: 320px"
            />
          </a-form-item>
          <a-form-item label="证件号码：" class="bdbtm1" name="cardNo">
            <a-input
              v-model:value="form.cardNo"
              placeholder="请填写证件号码"
              style="width: 320px"
              :disabled="editid != '' && editState == 20"
            />
          </a-form-item>
          <a-form-item label="手机号码：" class="bdbtm1" name="mobile">
            <a-input v-model:value="form.mobile" placeholder="请填写手机号码" style="width: 320px" />
          </a-form-item>
          <a-form-item
            label="电子邮箱："
            class="bdbtm1 required"
            name="email"
            v-if="form.cardType && form.cardType != 1"
          >
            <a-input v-model:value="form.email" placeholder="请填写邮箱" style="width: 320px" />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" class="add_submit" @click="submitAddUser" :loading="loading">
              {{ editid ? "编辑" : "添加" }}乘客
            </a-button>
          </a-form-item>
        </a-form>
        <div class="close_add" @click="addvisible = false">
          <CloseCircleOutlined :style="{ fontSize: '20px' }" />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { ref, watch, provide, computed, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import homeApi from "@axios/home";
import myApi from "@axios/my";
import { message, Modal } from "ant-design-vue";
import { PlusCircleFilled, CloseCircleOutlined } from "@ant-design/icons-vue";
import format from "@assets/js/format";

export default {
  name: "rob",
  components: {
    PlusCircleFilled,
    CloseCircleOutlined
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    let moreShow = ref(false);

    let userList = ref([]);
    let contact = ref("");

    let initialize = JSON.parse(localStorage.getItem("rob"));

    let mainDate = format.formatDate1(route.query.choseDate);

    let trainList = ref([]);

    let totleDetail = ref({
      trainSearchBo: {
        trains: []
      }
    });

    let dataList = ref([]);

    for (var i = 1; i <= 4; i++) {
      let time = new Date(new Date(mainDate).getTime() + 86400000 * i);
      dataList.value.push({
        ajaxdate: format.formatDate1(time),
        showdate: format.formatDateWeek(time),
        chose: false
      });
    }

    let trainNoList = computed(() => {
      return trainList.value.map((element) => {
        return element.trainNo;
      });
    });

    let choseSeatList = ref([]);

    let setSeatList = computed(() => {
      let arr = [];
      arr = [...initialize.tickets];
      trainList.value.forEach((element) => {
        if (element.checked) {
          element.tickets.forEach((item) => {
            let arrseatid = arr.map((data) => {
              return data.seatType;
            });
            if (arrseatid.indexOf(item.seatType) == -1) {
              arr.push(item);
            }
          });
        }
      });

      let waparr = arr.map((element) => {
        return element.seatType;
      });

      choseSeatList.value.forEach((ele, index) => {
        if (waparr.indexOf(ele) > -1) {
        } else {
          choseSeatList.value.splice(choseSeatList.value.indexOf(ele), 1);
        }
      });

      return arr;
    });

    let choseTrainNum = computed(() => {
      let cont = 1;
      trainList.value.forEach((element) => {
        if (element.checked) {
          cont++;
        }
      });
      return cont;
    });

    // 保险
    let insuranceList = ref([]);
    const getInsuranceList = () => {
      homeApi.getInsuranceList().then((res) => {
        console.log(res);
        // insuranceList.value = [
        //   {
        //     id: 1,
        //     insuranceName: "乘意险",
        //     insuredAmount: 600000,
        //     premium: 10
        //   },
        //   {
        //     id: 2,
        //     insuranceName: "乘意险2222",
        //     insuredAmount: 200000,
        //     premium: 20
        //   }
        // ]
        insuranceList.value = res;
        insuranceList.value.forEach((item) => {
          item.isSelected = false;
          // if (item.insuranceType === '1002') {
          //   item.isSelected = true
          // }
        });
        console.log(insuranceList.value);
      });
    };
    //获取保险
    getInsuranceList();
    const changeInsurance = (item) => {
      // console.log(item)
      item.isSelected = !item.isSelected;
      robPre();
    };

    const robPre = () => {
      let params = {
        fromStation: initialize.fromStation,
        toStation: initialize.toStation,
        mainTrain: {
          trainNo: initialize.trainNo,
          date: mainDate,
          seatClass: route.query.seat
        }
      };

      //需要新的参数计算价钱  坐席 车次
      let trainNosarr = [];
      trainList.value.forEach((ele) => {
        if (ele.checked) {
          trainNosarr.push(ele.trainNo);
        }
      });

      let seatlistarr = [];

      choseSeatList.value.forEach((ele) => {
        seatlistarr.push(ele);
      });

      var insuranceIds = [];
      insuranceList.value.forEach((item) => {
        if (item.isSelected) {
          insuranceIds.push(item.id);
        }
      });

      let passengersArr = [];

      userList.value.forEach((element) => {
        if (element.checked) {
          passengersArr.push({
            id: element.id,
            childrenNum: element.children.length,
            insuranceIds: insuranceIds.length ? insuranceIds.join("|") : null
          });
        }
      });

      params.trainNos = trainNosarr.join("|");
      params.seatClassCode = seatlistarr.join("|");
      params.passengers = passengersArr;
      // 保险

      homeApi.robPre(params).then((res) => {
        totleDetail.value = res;

        if (!trainList.value.length) {
          if (res.trainSearchBo) {
            trainList.value = res.trainSearchBo.trains.splice(0, 5);
          }

          trainList.value.forEach((element) => {
            element.checked = false;
          });
        }
      });
    };

    robPre();

    const getUserList = () => {
      myApi.getUserListNopage({}).then((res) => {
        //原有查看是否需要更新状态
        let idarr = userList.value.map((item) => {
          return item.id;
        });
        let newidarr = res.map((item) => {
          return item.id;
        });
        res.forEach((element) => {
          if (idarr.indexOf(element.id) > -1) {
            userList.value[idarr.indexOf(element.id)].state = element.state;
          } else {
            element.checked = false;
            element.children = [];
            userList.value.push(element);
          }
        });

        userList.value.forEach((element, index) => {
          if (newidarr.indexOf(element.id) > -1) {
          } else {
            userList.value.splice(index, 1);
          }
        });
      });
    };

    //获取乘客列表
    getUserList();

    let editState = ref(false);
    let form = ref({
      passengerType: 1,
      cardType: undefined,
      name: "",
      cardNo: "",
      mobile: "",
      sex: "M",
      birthday: undefined
    });

    let addvisible = ref(false);
    let editid = ref("");

    const addUserAction = () => {
      form.value.passengerType = 1;
      form.value.cardType = undefined;
      form.value.sex = "M";
      form.value.birthday = undefined;
      form.value.name = "";
      form.value.cardNo = "";
      form.value.mobile = "";
      form.value.email = "";
      addvisible.value = true;
      editid.value = "";
    };

    const checkTrain = (index) => {
      if (!trainList.value[index].checked) {
        if (choseTrainNum.value >= 7) {
          message.error("您最多选择7个备选车次");
        } else {
          trainList.value[index].checked = !trainList.value[index].checked;
        }
      } else {
        trainList.value[index].checked = !trainList.value[index].checked;
      }
      robPre();
    };

    let choseTrainShow = ref(false);

    const addTrainList = (item, tag) => {
      if (tag) return;
      item.checked = false;
      trainList.value.push(item);
      // choseTrainShow.value = false
    };

    const choseSeat = (seatType) => {
      if (choseSeatList.value.indexOf(seatType) > -1) {
        choseSeatList.value.splice(choseSeatList.value.indexOf(seatType), 1);
      } else {
        if (choseSeatList.value.length >= 8) {
          message.error("您最多选择8中座位");
        } else {
          choseSeatList.value.push(seatType);
        }
      }
      robPre();
    };

    let passengerLength = computed(() => {
      let checklength = 0;
      userList.value.forEach((ele) => {
        if (ele.checked) {
          checklength++;
          if (ele.children.length) {
            checklength += ele.children.length;
          }
        }
      });
      return checklength;
    });

    const selectUser = (index, tag) => {
      if (tag) return;
      if (!userList.value[index].checked) {
        if (passengerLength.value == 5) {
          message.error("最多选择5名乘客");
        } else {
          userList.value[index].checked = !userList.value[index].checked;
        }
      } else {
        userList.value[index].checked = !userList.value[index].checked;
        userList.value[index].children = [];
      }
      robPre();
    };

    const addChildren = (index) => {
      if (passengerLength.value == 5) {
        message.error("最多选择5名乘客");
        return;
      }

      userList.value[index].children.push({
        name: userList.value[index].name,
        passengerTypeValue: "儿童"
      });
      robPre();
    };

    const deleteChildren = (index) => {
      userList.value[index].children.splice(0, 1);
      robPre();
    };

    let itemref = [];

    const toref = (el) => {
      itemref.push(el);
    };

    //添加编辑刷新删除乘客逻辑相关
    const typeList = ref([
      {
        name: "成人",
        val: 1
      },
      {
        name: "儿童",
        val: 2
      },
      {
        name: "学生",
        val: 3
      },
      {
        name: "残军",
        val: 4
      }
    ]);
    const cardType = ref([
      {
        name: "中国居民身份证",
        val: 1
      },
      {
        name: "护照",
        val: 2
      },
      {
        name: "台湾居民来往大陆通行证",
        val: 3
      },
      {
        name: "港澳居民来往内地通行证",
        val: 4
      },
      {
        name: "外国人永久居留身份证",
        val: 5
      },
      {
        name: "港澳台居民居住证",
        val: 6
      }
    ]);

    var checkPhone = async (rule, value) => {
      if (!value) {
        return Promise.reject("手机号不能为空");
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          Promise.resolve();
        } else {
          return Promise.reject("请输入正确的手机号");
        }
      }
    };

    let checkDistributorId = (rule, value, callback) => {
      if (!value) {
        return Promise.reject("请选择证件类型");
      } else {
        return Promise.resolve();
      }
    };

    let birthday = (rule, value, callback) => {
      if (!value && form.value.cardType != 1) {
        return Promise.reject("请选择生日");
      } else {
        return Promise.resolve();
      }
    };

    let email = (rule, value, callback) => {
      if (!value && form.value.cardType != 1) {
        return Promise.reject("请输入邮箱");
      } else {
        return Promise.resolve();
      }
    };

    let loading = ref(false);

    const submitAddUser = () => {
      itemref[0]
        .validate()
        .then(() => {
          console.log(1);
          //验证规则是否合法
          loading.value = true;
          let params = {
            name: form.value.name,
            passengerType: form.value.passengerType,
            cardNo: form.value.cardNo,
            mobile: form.value.mobile,
            cardType: form.value.cardType,
            sex: form.value.cardType != 1 ? form.value.sex : null,
            birthday: form.value.birthday
          };
          if (editid.value) {
            params.id = editid.value;
            myApi
              .editUser(params)
              .then((res) => {
                loading.value = false;
                addvisible.value = false;
                message.success("修改成功");
                getUserList();
              })
              .catch((err) => {
                loading.value = false;
              });
          } else {
            myApi
              .addUser(params)
              .then((res) => {
                loading.value = false;
                addvisible.value = false;
                message.success("添加成功");
                getUserList();
              })
              .catch((err) => {
                loading.value = false;
              });
          }
        })
        .catch((err) => {
          loading.value = false;
        });
    };
    const editUser = (index) => {
      editid.value = userList.value[index].id;
      editState.value = userList.value[index].state;
      form.value.passengerType = parseInt(userList.value[index].passengerType);
      form.value.cardType = parseInt(userList.value[index].cardType);
      form.value.name = userList.value[index].name;
      form.value.sex = userList.value[index].sex || "M";
      form.value.birthday = userList.value[index].birthday;
      form.value.email = userList.value[index].email;
      if (userList.value[index].cardNoValue) {
        form.value.cardNo = userList.value[index].cardNoValue;
      } else {
        form.value.cardNo = userList.value[index].cardNo;
      }

      form.value.mobile = userList.value[index].mobileValue;

      addvisible.value = true;
    };

    const reloadUser = () => {
      getUserList();
    };

    const deleteUser = (index) => {
      Modal.confirm({
        content: "请确定删除" + userList.value[index].name + "?",
        onOk() {
          myApi.delUser(userList.value[index].id).then((res) => {
            getUserList();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        }
      });
    };

    let submitloading = ref(false);

    const submitRobOrder = () => {
      if (!limitdate.value) {
        message.error("请选择截止日期");
        return;
      }

      if (!passengerLength.value) {
        message.error("请至少选择一个乘客");
        return;
      }

      if (!contact.value) {
        message.error("请输入联系方式");
        return;
      }

      let params = {
        fromStation: initialize.fromStation,
        toStation: initialize.toStation,
        mainTrain: {
          trainNo: initialize.trainNo,
          date: mainDate,
          seatClass: route.query.seat
        }
      };
      let dateArr = [];
      dataList.value.forEach((ele) => {
        if (ele.chose) {
          dateArr.push(ele.ajaxdate);
        }
      });
      //选择的日期
      params.dates = dateArr.join("|");

      let trainNosArr = [];
      trainList.value.forEach((ele) => {
        if (ele.checked) {
          dateArr.push(ele.trainNo);
        }
      });
      //选择的日期
      params.trainNos = trainNosArr.join("|");

      let seatlistarr = [];

      choseSeatList.value.forEach((ele) => {
        seatlistarr.push(ele);
      });

      params.seatClassCode = seatlistarr.join("|");

      params.contact = {
        name: "顾客",
        mobile: contact.value
      };

      var insuranceIds = [];
      insuranceList.value.forEach((item) => {
        if (item.isSelected) {
          insuranceIds.push(item.id);
        }
      });

      let passengersArr = [];
      userList.value.forEach((element) => {
        if (element.checked) {
          passengersArr.push({
            id: element.id,
            childrenNum: element.children.length,
            insuranceIds: insuranceIds.length ? insuranceIds.join("|") : null
          });
        }
      });

      params.passengers = passengersArr;

      //渠道PC
      params.saleChannel = 2;

      params.queryKey = totleDetail.value.queryKey;

      params.expiryTime = limitdate.value;

      submitloading.value = true;

      homeApi
        .robOrder(params)
        .then((res) => {
          let paypa = {
            orderCode: res.orderCode,
            appPlatform: 10,
            returnUrl: window.location.origin + "/train_pc/robDetail?code=" + res.orderCode
          };
          console.log("yer");
          homeApi.robToPay(paypa).then((rest) => {
            submitloading.value = false;
            window.location.href = rest.cashierUrl + "?advanceOrderNo=" + rest.advanceOrderNo + "&type=train";
          });

          // router.push({
          //     name : 'robDetail',
          //     query : {
          //         code : res.orderCode
          //     }
          // })
        })
        .catch((e) => {
          submitloading.value = false;
        });
    };

    let limitdate = ref("");

    const insuredAmountText = (amount) => {
      if (amount >= 10000) {
        return amount / 10000 + "万";
      } else {
        return amount;
      }
    };

    let limitMaxDay = computed(() => {
      let rdata = mainDate;
      dataList.value.forEach((ele) => {
        if (ele.chose) {
          rdata = ele.ajaxdate;
        }
      });
      return rdata;
    });

    const limitDisabledDate = (current) => {
      return current < moment().add(-1, "d") || current > new Date(limitMaxDay.value);
    };

    const changeDate = (item) => {
      item.chose = !item.chose;
      limitdate.value = "";
    };

    // 经停
    let stopStateList = ref([]);
    let stateListShow = ref(false);

    const stopShowAction = (item) => {
      stateListShow.value = true;
      // console.log(item);
      let params = {
        trainNo: item.trainNo,
        fromStation: item.fromStation,
        toStation: item.toStation,
        trainDate: mainDate
        // trainCode: item.trainLongNo
      };
      homeApi.trainStopStation(params).then((res) => {
        stopStateList.value = res.stations;
      });
    };
    const close = () => {
      stateListShow.value = false;
    };

    return {
      changeDate,
      limitDisabledDate,
      insuredAmountText,
      changeInsurance,
      insuranceList,
      submitloading,
      limitdate,
      submitRobOrder,
      deleteUser,
      reloadUser,
      editUser,
      editState,
      loading,
      submitAddUser,
      typeList,
      cardType,
      editid,
      form,
      addvisible,
      passengerLength,
      deleteChildren,
      addChildren,
      selectUser,
      dataList,
      choseSeat,
      choseSeatList,
      setSeatList,
      choseTrainNum,
      addTrainList,
      trainNoList,
      choseTrainShow,
      totleDetail,
      checkTrain,
      mainDate,
      initialize,
      trainList,
      contact,
      addUserAction,
      moreShow,
      userList,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      toref,
      rules: {
        cardType: [{ validator: checkDistributorId, trigger: "blur" }],
        name: [{ required: true, message: "请输入乘客姓名", trigger: "blur" }],
        birthday: [{ validator: birthday, trigger: "change", type: "object" }],
        cardNo: [{ required: true, message: "请输入证件号码", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        email: [{ validator: email, trigger: "blur", type: "object" }]
      },
      stopStateList,
      stopShowAction,
      stateListShow,
      close
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.passengers_disabel {
  background: #f8f8f8 !important;
  color: #cdcccd !important;
}
.showdatacontent > div {
  width: 130px !important;
}
.passengers_active {
  border-color: #3999fb !important;
}
.confirm_list {
  border-bottom: 1px dashed #bdc0c8;
  padding: 15px 0;
  display: flex;
  align-items: center;
  .passengers_name {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
  .passengers_type {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #6d7278;
  }
}
.addchildredn {
  color: #fd5739;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  cursor: pointer;
  img {
    margin-right: 8px;
  }
}
.delete_passengers {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  div {
    cursor: pointer;
  }
}
.train_list {
  background: #fff;
  width: 100%;
  padding: 15px 20px;

  .scroll {
    max-height: 600px;
    overflow-y: scroll;
  }
  .train_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    padding-bottom: 10px;
    border-bottom: 3px solid #cdcccd;
    line-height: 25px;
  }
  .t1,
  .t2,
  .t3 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin-top: 10px;
  }
  .row {
    border-top: 0.5px solid #cdcccd;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .searchBtn {
    height: 25px;
    line-height: 25px;
    background: #ffab00;
    border-color: #ffab00;
    border-radius: 2px;
    font-size: 14px;
  }
  .no_confim {
    background: #cdcccd !important;
    border-color: #cdcccd;
  }
}
.add_ticket {
  color: #3999fb !important;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contact {
  margin-top: 35px;
  .contact_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .contact_content {
    margin-top: 13px;
    // background: #F8F8F8;
    border: 0.5px solid #cdcccd;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid #cdcccd;
    .tips {
      font-size: 10px;
    }
    span {
      width: 80px;
    }
  }
}
.submitBtn {
  background: #ffab00;
  width: 100%;
  border-color: #ffab00;
  height: 68px;
  line-height: 68px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  margin-top: 50px;
  margin-bottom: 30px;
}
.passengers_cont {
  margin-top: 35px;
  position: relative;
  padding-bottom: 25px;
  .passengers_more {
    position: absolute;
    right: 0px;
    color: #6d7278;
    border: 0.5px solid #979797;
    padding: 2px 9px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    cursor: pointer;
    border-radius: 2px;
  }
  .passengers_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    border-bottom: 1px solid #dedfe3;
    padding-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .add {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      border-radius: 2px;
      border: 0.5px solid #cdcccd;
      padding: 4px 7px;
      cursor: pointer;
    }
  }
  .passengers_list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    // max-height: 54px;
    // overflow: hidden;

    .passengers_item {
      margin-right: 7px;
      width: 88px;
      height: 62px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      border-radius: 2px;
      border: 0.5px solid #cdcccd;
      margin-top: 10px;
      cursor: pointer;
      position: relative;
      .action_sanjiao {
        width: 0;
        height: 0;
        border-top: 8px solid transparent !important;
        border-bottom: 8px solid transparent !important;
        border-right: 8px solid transparent !important;
        border-left: 8px solid #3999fb !important;
        position: absolute !important;
        right: -8px !important;
        top: -8px !important;
        transform: rotate(-45deg) !important;
      }

      .operation {
        display: flex;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6d7278;
        justify-content: space-around;

        // div{

        // }
      }
      .name {
        // line-height: 35px;
        line-height: 17px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;

        div {
          text-align: center;
        }
        .tips {
          font-size: 10px;
          overflow: hidden;
          color: #cdcccd;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 14px;
          margin-bottom: 2px;
        }
        .line {
          height: 0.5px;
          background: #dedfe3;
          width: 74px;
          margin-left: 7px;
        }
      }
    }
  }
}
.moreShow {
  max-height: 500px !important;
}
.seat_content {
  display: flex;
  justify-content: flex-start;
  // margin-top: 8px;
  flex-wrap: wrap;
  .action_sanjiao {
    width: 0;
    height: 0;
    border-top: 8px solid transparent !important;
    border-bottom: 8px solid transparent !important;
    border-right: 8px solid transparent !important;
    border-left: 8px solid #3999fb !important;
    position: absolute !important;
    right: -8px !important;
    top: -8px !important;
    transform: rotate(-45deg) !important;
  }
  & > div {
    position: relative;
    width: 120px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    padding: 0 6px;
    height: 35px;
    border-radius: 2px;
    border: 1px solid #cdcccd;
    line-height: 35px;
    margin-right: 10px;
    cursor: pointer;
    margin-top: 10px;
  }
}
.passengers_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  border-bottom: 1px solid #dedfe3;
  // padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .add {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    border-radius: 2px;
    border: 0.5px solid #cdcccd;
    padding: 4px 7px;
    cursor: pointer;
  }
}
.input {
  // background: #F8F8F8;
  border: none;
  border-bottom: 1px solid #cdcccd;
  outline: none;
}
.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  .left {
    width: 760px;
  }
  .right {
    width: 410px;
  }
}

.ticket_type_after:after {
  content: "";
  display: block;
  width: 212px;
  height: 99px;
}
.ticket_type {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  cursor: pointer;

  & > div {
    width: 212px;
    margin-right: 40px;
    border-radius: 4px;
    border: 0.5px solid rgba(0, 0, 0, 0.25);
    box-sizing: border-box !important;
    position: relative;
    margin-bottom: 10px;
    padding: 7px 10px;
    .time_cont {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      align-items: center;
      .take_time {
        font-size: 12px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #000000;
      }
    }
    .state_cont {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
    }
    .price_line {
      margin: 5px 3px;
      height: 1px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
    }
    .train_no {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }
  }
}
.active_ticket {
  // border: none!important;
  // background: #0D6DBF;
  border-color: #3999fb !important;

  .action_sanjiao {
    width: 0;
    height: 0;
    border-top: 16.5px solid transparent;
    border-bottom: 16.5px solid transparent;
    border-right: 16.5px solid transparent;
    border-left: 16.5px solid #3999fb;
    position: absolute;
    right: -17px;
    top: -17px;
    transform: rotate(-45deg);
  }
}
.no_ticket {
  border: none !important;
  background: #f8f8f8;
  color: rgba(0, 0, 0, 0.25);
}

.ticket_detail {
  background: #fafdff;
  padding: 20px;
  border: 0.5px solid #0d6dbf;
  .top {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 16px;
    line-height: 20px;
    .train_no {
      color: #fd5839;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
  }
  .time_cont {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .often {
      font-size: 14px;
      text-align: center;
      position: relative;
      .box {
        width: 430px;
        background: #fff;
        border: 0.5px solid #cdcccd;
        padding: 26px 13px;
        position: absolute;
        z-index: 10;
        right: 0;
        top: 70px;
      }
      img {
        width: 95px;
      }

      .card {
        width: 20px;
      }
    }
  }
  .state {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    text-align: center;
  }
}
.price_content {
  padding: 20px;
  background: #f8f8f8;
  border: 0.5px solid #cdcccd;
  border-top: none;
  .price_title {
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 16px;
    color: #000000;
  }
  .price_item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
  }
  .price_totle {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
    font-family: PingFangSC-Medium, PingFang SC;
    .num {
      font-size: 20px;
      color: #ffab00;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
  }
}
.add_content {
  padding: 20px;
  // background: #F8F8F8;
  border: 0.5px solid #cdcccd;
}
.form_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  padding-left: 10px;
  padding-bottom: 12px;
  margin-top: 20px;
  border-bottom: 3px solid #cdcccd;
  margin-bottom: 10px;
}
.add_content {
  ::v-deep(.ant-select-selection--single) {
    height: 32px !important;
  }
}

.add_content {
  ::v-deep(.ant-select-selection__rendered) {
    line-height: 32px !important;
  }
}
.close_add {
  position: absolute;
  top: 43px;
  right: 20px;
  cursor: pointer;
}
.bdbtm1 {
  border-bottom: 1px solid #cdcccd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.add_submit {
  width: 144px;
  height: 40px;
  line-height: 40px;
  background: #ffab00;
  border-color: #ffab00;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 20px;
}
.bdbtm {
  border-bottom: 3px solid #cdcccd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
// 保险
.insurance {
  margin-top: 40px;
  .insurance_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    height: 20px;
    line-height: 1.8;
    img {
      height: 24px;
      margin-right: 5px;
      vertical-align: sub;
    }
  }
  .insurance_content {
    margin-top: 13px;
    // background: #F8F8F8;
    border: 0.5px solid #cdcccd;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 24px;
    border-bottom: 1px solid #cdcccd;
    border-radius: 2px;
    .insurance-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #cdcccd;
      font-size: 14px;
      color: #000000;
      font-family: PingFangSC-Light, PingFang SC;
      .name {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
      }
      span {
        color: #fd5739;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .insurance-bottom {
      span {
        color: #3999fb;
      }
    }
  }
}
// 保险
.insurance {
  margin-top: 40px;
  .insurance_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    height: 22px;
    line-height: 22px;
    display: flex;
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    img {
      height: 20px;
      margin-right: 10px;
      vertical-align: sub;
    }
  }
  .insurance_content {
    margin-top: 13px;
    // background: #F8F8F8;
    border: 0.5px solid #cdcccd;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 24px;
    border-bottom: 1px solid #cdcccd;
    border-radius: 2px;
    cursor: pointer;
    .insurance-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #cdcccd;
      font-size: 14px;
      color: #000000;
      font-family: PingFangSC-Light, PingFang SC;
      .name {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
      }
      span {
        color: #fd5739;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .insurance-bottom {
      font-family: PingFangSC-Light, PingFang SC;
      span {
        color: #3999fb;
      }
    }
  }
}
// 经停
.box_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid #cdcccd;
  padding-bottom: 6px;
}
.title {
  color: #fff;
  font-size: 20px;
}
.box-content {
  // padding:26px 20px;
  margin-top: 11px;
}
.row_list_content {
  max-height: 400px;
  overflow-y: auto;
}
.row_content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  text-align: center;
}
.row_list {
  margin-bottom: 8px;
}
.row_title {
  margin-bottom: 11px;
}
</style>
